export const mealsOption = [
  { id: 'Breakfast', label: 'Breakfast' },
  { id: 'Half Board', label: 'Half Board' },
  { id: 'Non Breakfast', label: 'Non Breakfast' },
];
